import React from 'react';
import {
  Divider,
  Flex,
  Chip,
  useTheme,
  useMediaQuery,
} from '@dripcapital/dripui-v1';
import { Typography } from '@dripcapital/dripui-v1';
import { ChipColor } from 'types';
import { useTranslation } from 'react-i18next';
import { DAJ_COLORS } from 'utils';

type Props = {
  title: string;
  label?: string;
  chipLabel?: string;
  newChip?: boolean;
  chipColor?: ChipColor;
  initialVariant?: 'h1' | 'h2' | 'h3' | 'h4';
};

const Heading: React.FC<Props> = ({
  title,
  chipLabel,
  label,
  chipColor = 'info',
  initialVariant = 'h2',
}: Props) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const smLimit = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Flex dataTestId="primary-header-element" direction="column">
      <Flex alignItems={'center'} spacing={3}>
        <Typography
          variant={smLimit ? 'h3' : initialVariant}
          fontWeight="bold"
          _sx={{ width: 'fit-content' }}
        >
          {title}
          <Divider
            orientation="horizontal"
            borderColor={DAJ_COLORS.WEALTHY_GREEN}
            flexItem
          />
        </Typography>
        {chipLabel && (
          <Chip
            label={chipLabel}
            color={chipColor}
            size="medium"
            _sx={{
              div: {
                width: 'max-content',
              },
            }}
          />
        )}
      </Flex>
      {label && (
        <Typography variant="label">
          {t('label_profile')}: {label}
        </Typography>
      )}
    </Flex>
  );
};

export default Heading;
